module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('h1', {
    staticClass: "role-switch",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.autoLogin($event)
      }
    }
  }, [_vm._s(_vm.curcheName ? _vm.curcheName : '少儿之家园点端')])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop
    }
  }, [_vm._h('div', {
    staticClass: "main-page",
    staticStyle: {
      "padding-bottom": "60px"
    }
  }, [_vm._h('div', {
    staticClass: "banner indexbanner",
    staticStyle: {
      "height": "36vw"
    }
  }, [_vm._h('mt-swipe', {
    attrs: {
      "auto": 4000
    }
  }, [_vm._l((_vm.banners), function(item) {
    return _vm._h('mt-swipe-item', [_vm._h('router-link', {
      attrs: {
        "to": {
          path: '/ad/info/' + item.adId
        }
      }
    }, [_vm._h('img', {
      attrs: {
        "src": item.baseAcessPath + item.adImg
      }
    })])])
  })])]), " ", " ", (!_vm.isVisitor) ? _vm._h('div', {
    staticClass: "teachers bg-white"
  }, [_vm._h('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.teacherList), function(item, index) {
    return _vm._h('li', [_vm._h('router-link', {
      staticClass: "block text-center",
      attrs: {
        "to": {
          path: '/teacher/detail/' + item.teacherId
        }
      }
    }, [_vm._h('span', {
      staticClass: "img-wrap small"
    }, [_vm._h('img', {
      attrs: {
        "src": item.teacherIcon ? (item.baseAcessPath + item.teacherIcon) : _vm.img_default,
        "width": "100%"
      }
    })]), " ", _vm._h('small', [_vm._s(item.teacherName)])])])
  })])]) : _vm._e(), " ", _vm._h('div', {
    staticClass: "tools"
  }, [(_vm.isVisitor) ? _vm._h('ul', {
    staticClass: "clearfix bg-white"
  }, [_vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('a', {
    staticClass: "icon-yuandian",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["园点公开"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('a', {
    staticClass: "icon-laoshi",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["老师"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('a', {
    staticClass: "icon-xuesheng",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["学生"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('a', {
    staticClass: "icon-chengji",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["成绩"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('a', {
    staticClass: "icon-huoshi",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["今日伙食"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('a', {
    staticClass: "icon-ziliao",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["工作资料"]), _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('a', {
    staticClass: "icon-dianming",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["点名"]), _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('a', {
    staticClass: "icon-shipin",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["监护视频"])])]) : _vm._h('ul', {
    staticClass: "clearfix bg-white"
  }, [_vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('router-link', {
    staticClass: "icon-news",
    attrs: {
      "to": {
        path: '/dynamic/list/0'
      }
    }
  }), _vm._h('span', ["动态"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('router-link', {
    staticClass: "icon-huoshi",
    attrs: {
      "to": {
        path: '/dynamic/list/1'
      }
    }
  }), _vm._h('span', ["今日伙食"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('router-link', {
    staticClass: "icon-chengji",
    attrs: {
      "to": {
        path: '/score/list/0'
      }
    }
  }), _vm._h('span', ["成绩"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('router-link', {
    staticClass: "icon-dianming",
    attrs: {
      "to": {
        path: '/rollcall/list'
      }
    }
  }), _vm._h('span', ["点名"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('router-link', {
    staticClass: "icon-yuandian",
    attrs: {
      "to": {
        path: '/curche/detail'
      }
    }
  }), _vm._h('span', ["园点公开"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('router-link', {
    staticClass: "icon-grow",
    attrs: {
      "to": {
        path: '/heightAndWeight/list/0'
      }
    }
  }), _vm._h('span', ["身高体重"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('a', {
    staticClass: "icon-homework",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goHomework()
      }
    }
  }), _vm._h('span', ["今日作业"])]), " ", _vm._h('li', {
    staticClass: "line-y"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('a', {
    staticClass: "icon-shipin",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getVideo()
      }
    }
  }), _vm._h('span', ["监护视频"])]), " ", _vm._h('li', {
    staticClass: "line-y hide"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), _vm._h('router-link', {
    staticClass: "icon-ziliao",
    attrs: {
      "to": {
        path: '/information/list'
      }
    }
  }), _vm._h('span', ["托管学院"])])]), " "]), " ", _vm._h('div', {
    staticClass: "tg-school"
  }, [_vm._h('ul', {
    staticClass: "list-group-item"
  }, [_vm._h('li', [_vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('div', {
    staticClass: "pull-left padding-10",
    staticStyle: {
      "border-left": "5px solid #f3aab9"
    }
  }, ["托管学院"]), " ", _vm._h('router-link', {
    staticClass: "pull-right font-12 padding-10 margin-x-15",
    staticStyle: {
      "color": "#f3aab9"
    },
    attrs: {
      "to": {
        path: '/information/list'
      }
    }
  }, ["更多"])]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "scroll-wrap"
  }, [_vm._h('div', {
    staticClass: "tg-scroll"
  }, [_vm._l((_vm.topInfos.returnList), function(info) {
    return _vm._h('router-link', {
      staticClass: "clearfix padding-15 son",
      attrs: {
        "tag": "div",
        "to": {
          'path': '/information/detail/' + info.contentId
        }
      }
    }, [_vm._h('div', {
      staticClass: "pic pull-left"
    }, [_vm._h('img', {
      staticClass: "pull-left",
      attrs: {
        "src": _vm.topInfos.baseAcessPath + info.contentImage,
        "width": "100%"
      }
    })]), " ", _vm._h('div', {
      staticClass: "txt"
    }, [_vm._h('p', {
      staticClass: "tit"
    }, [_vm._s(info.contentTitle)]), " ", _vm._h('p', {
      staticClass: "gray font-12"
    }, [_vm._s(info.contentAbstract)])])])
  })])])])])])])]), " ", _vm._h('div', {
    staticClass: "navbar"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('ul', {
    staticClass: "clearfix text-center"
  }, [_vm._m(0), " ", (_vm.isVisitor) ? [_vm._h('li', [_vm._h('router-link', {
    staticClass: "img-news",
    attrs: {
      "to": {
        path: '/user/center/NewsClass'
      }
    }
  }, [_vm._h('span', ["消息"])])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "icon-add icon",
    attrs: {
      "to": {
        path: '/quickadd'
      }
    }
  }, ["添加"])]), " ", _vm._h('li', [_vm._h('a', {
    staticClass: "img-contact",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }, [_vm._h('span', ["联系人"])])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "img-user",
    attrs: {
      "to": {
        path: '/user/center'
      }
    }
  }, [_vm._h('span', ["我的"])])])] : [_vm._h('li', [_vm._h('router-link', {
    staticClass: "img-xiaoxi",
    attrs: {
      "to": {
        path: '/user/center/NewsClass'
      }
    }
  }, [_vm._h('span', ["消息"])])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "icon-add icon",
    attrs: {
      "to": {
        path: '/quickadd'
      }
    }
  }, ["添加"])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "img-contact",
    attrs: {
      "to": {
        path: '/contact/list'
      }
    }
  }, [_vm._h('span', ["联系人"])])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "img-user",
    attrs: {
      "to": {
        path: '/user/center'
      }
    }
  }, [_vm._h('span', ["我的"])])])], " "])]), " ", _vm._h('mt-popup', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popupVisebleRole),
      expression: "popupVisebleRole"
    }],
    attrs: {
      "position": "top"
    },
    domProps: {
      "value": (_vm.popupVisebleRole)
    },
    on: {
      "input": function($event) {
        _vm.popupVisebleRole = $event
      }
    }
  }, [_vm._h('div', {
    staticClass: "margin-15 padding-15"
  }, [_vm._h('ul', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._l((_vm.login_data), function(item, index) {
    return _vm._h('li', {
      on: {
        "click": function($event) {
          _vm.selectCurche(index, item)
        }
      }
    }, [_vm._h('a', {
      staticClass: "block clearfix ",
      class: {
        'orange': (index == _vm.cookie_login_data.index)
      },
      staticStyle: {
        "padding": "10px 0"
      },
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._h('span', {
      staticClass: "col-xs-8",
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_vm._s(item.curcheName)]), " ", _vm._h('span', {
      staticClass: "col-xs-4"
    }, [_vm._s(item.jobName)])]), " ", _vm._h('div', {
      staticClass: "liner"
    })])
  })])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('li', [_vm._h('a', {
    staticClass: "img-home active"
  }, [_vm._h('span', ["管理"])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-05358d17!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = 171
// module chunks = 1